function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 172.16,
    height: 74.13,
    viewBox: "0 0 172.16 74.13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "g3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path7",
    d: "M715.8,512.41v9.64h20.37v20.14H715.8v23.87H694.89v-73.9h44.45l1.43,20.25Z",
    transform: "translate(-694.89 -492.16)",
    style: {
      fill: "#343838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9",
    d: "M800.47,503.52a36.92,36.92,0,0,1,0,51.39,35.09,35.09,0,0,1-50.32,0,36.92,36.92,0,0,1,0-51.39,35.09,35.09,0,0,1,50.32,0ZM769.35,544a5.86,5.86,0,0,0,1.83,4.29,6,6,0,0,0,4.4,1.82,5.78,5.78,0,0,0,4.34-1.82,6,6,0,0,0,1.77-4.29V514a6.11,6.11,0,0,0-1.77-4.4,5.82,5.82,0,0,0-4.34-1.82,6.23,6.23,0,0,0-6.23,6.22V544Z",
    transform: "translate(-694.89 -492.16)",
    style: {
      fill: "#343838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path11",
    d: "M843.51,566.28,833,547.56l-10.19,18.72h-23L821.72,528,801,492.16h23.65l8.65,16,8.75-16H865l-20.26,35.58,22.34,38.54Z",
    transform: "translate(-694.89 -492.16)",
    style: {
      fill: "#343838"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFox);
export default __webpack_public_path__ + "static/media/FOX.566c54003e7c4a2876cffda9179291be.svg";
export { ForwardRef as ReactComponent };